module.exports = __webpack_public_path__ + "img/vold_Mellom_speil_og_speil1.41a7d8c7.jpg";